@if (productTax(); as item) {
  <div class="flex flex-col gap-4">
    <div class="rounded-xl border border-slate-200 overflow-hidden bg-white shadow-sm">
      <div class="flex items-center gap-2 px-4 py-2.5 bg-slate-100 border-b border-slate-200">
        <span class="flex h-7 w-7 items-center justify-center rounded-lg bg-violet-100 text-violet-600">
          <i class="pi pi-info-circle text-sm"></i>
        </span>
        <span class="text-xs font-semibold text-slate-700 uppercase tracking-wide">Información general</span>
      </div>
      <div class="p-4">
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-3">
          <div class="sm:col-span-2">
            <p class="text-xs font-medium text-slate-500">Impuesto SAT</p>
            <p class="text-sm font-semibold text-slate-900">{{ item.tax?.displayName || item.tax?.taxKey || '—' }}</p>
            @if (item.tax?.description) {
              <p class="text-xs text-slate-500 mt-0.5">{{ item.tax.description }}</p>
            }
          </div>
          <div>
            <p class="text-xs font-medium text-slate-500">Clave</p>
            <p class="text-sm text-slate-700 font-mono">{{ item.tax?.taxKey || '—' }}</p>
          </div>
          <div>
            <p class="text-xs font-medium text-slate-500">Estado</p>
            <p-tag severity="secondary" class="text-xs" [value]="item.state === 'ACTIVE' ? 'Activo' : 'Inactivo'" />
          </div>
          <div>
            <p class="text-xs font-medium text-slate-500">Tasa</p>
            <p class="text-sm text-slate-700 tabular-nums">{{ item.taxRate != null ? (item.taxRate | number:'1.0-6') + '%' : '—' }}</p>
          </div>
          <div>
            <p class="text-xs font-medium text-slate-500">Monto</p>
            <p class="text-sm text-slate-700 tabular-nums">{{ item.taxAmount != null ? (item.taxAmount | number:'1.2-4') : '—' }}</p>
          </div>
          <div>
            <p class="text-xs font-medium text-slate-500">Tipo de aplicación</p>
            <p class="text-sm text-slate-700">{{ applicationTypeLabel(item.applicationType) || '—' }}</p>
          </div>
          <div>
            <p class="text-xs font-medium text-slate-500">Tipo de cobro</p>
            <p class="text-sm text-slate-700">{{ collectionTypeLabel(item.collectionType) || '—' }}</p>
          </div>
          <div>
            <p class="text-xs font-medium text-slate-500">Fecha de creación</p>
            <p class="text-sm text-slate-700">{{ item.createdAt ? (item.createdAt | date:'dd/MM/yyyy') : '—' }}</p>
          </div>
          <div>
            <p class="text-xs font-medium text-slate-500">Última actualización</p>
            <p class="text-sm text-slate-700">{{ item.updatedAt ? (item.updatedAt | date:'dd/MM/yyyy') : '—' }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
}
